import { BASE_URL } from '../api/client';

const ABSOLUTE_URL_RE = /^(?:https?:|data:|blob:|file:|content:|capacitor:)/i;

export function resolveBackendAssetUrl(value?: string | null): string {
  if (!value) return '';

  const trimmed = value.trim();
  if (!trimmed) return '';

  if (ABSOLUTE_URL_RE.test(trimmed)) return trimmed;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;

  const base = BASE_URL.replace(/\/+$/, '');
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${base}${path}`;
}
